(function(){
  const cache = {};
  let observer;

  function parseAndAppend(html) {
    const doc       = new DOMParser().parseFromString(html, 'text/html');
    const container = document.querySelector('.row__collection-list.max-width');
    if (!container) return;

    // grab only the new cards
    const newCards = doc.querySelectorAll('.row__collection-list.max-width > div');
    newCards.forEach(card => container.appendChild(card));

    // update or remove the Load More button
    const newBtn = doc.querySelector('#load-more-button');
    const btn    = document.getElementById('load-more-button');
    if (newBtn) {
      btn.href = newBtn.href;
    } else {
      btn.remove();
      observer.disconnect();
    }
  }

  function prefetch(url) {
    if (cache[url]) return;
    fetch(url, { credentials: 'same-origin' })
      .then(res => res.text())
      .then(html => { cache[url] = html; })
      .catch(console.error);
  }

  function init() {
    const btn = document.getElementById('load-more-button');
    if (!btn) return;

    // 1) Prefetch when the button nears the viewport
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          prefetch(btn.href);
          observer.unobserve(btn);
        }
      });
    }, { rootMargin: '200px' });
    observer.observe(btn);

    // 2) On click, use the cached HTML if available
    btn.addEventListener('click', function(e) {
      const url = btn.href;
      if (cache[url]) {
        e.preventDefault();
        parseAndAppend(cache[url]);
      }
      // otherwise the link behaves normally
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
